import React, { useMemo } from 'react';
import { Drawer } from '@mui/material';
import { groupSessionsByDate } from './utils/sessions';
import { SidebarContent } from './SessionContent';
import { WithSmallScreen } from '../../common/WithSmallScreen';

/** Full sidebar width when expanded. */
export const SIDEBAR_WIDTH = 180;

/** Narrow icon-strip width when collapsed on desktop. */
export const MINI_WIDTH = 64;

/* ══════════════════════════════════════════════════════════════
 *  Main SessionSidebar Component
 * ══════════════════════════════════════════════════════════════ */

export const SessionSidebar = WithSmallScreen(
  ({
    sessions = [],
    activeSessionId,
    isLoadingSessions,
    isOpen,
    onToggle,
    onNewSession,
    onSelectSession,
    isSmall,
  }) => {
    const isMobile = isSmall;

    const sessionGroups = useMemo(() => groupSessionsByDate(sessions), [sessions]);

    // On mobile, collapsed width is 0 (fully hidden).
    // On desktop, collapsed width is MINI_WIDTH (64px icon strip).
    const collapsedWidth = isMobile ? 0 : MINI_WIDTH;
    const currentWidth = isOpen ? SIDEBAR_WIDTH : collapsedWidth;

    const isHidden = currentWidth === 0;

    return (
      <Drawer
        variant="permanent"
        className={`sessionSidebarDrawer${isHidden ? ' isHidden' : ''}`}
        PaperProps={{
          className: `sessionSidebarDrawerPaper${isHidden ? ' isHidden' : ''}`,
        }}
        style={{ '--session-sidebar-width': `${currentWidth}px` }}
        sx={{
          width: currentWidth,
          flexShrink: 0,
          overflow: 'hidden',
          '& .MuiDrawer-paper': {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            width: currentWidth,
            height: '100%',
            minHeight: '100%',
            overflowX: 'hidden',
            boxSizing: 'border-box',
          },
        }}
      >
        <SidebarContent
          isExpanded={isOpen}
          sessions={sessions}
          sessionGroups={sessionGroups}
          activeSessionId={activeSessionId}
          isLoadingSessions={isLoadingSessions}
          onToggle={onToggle}
          onNewSession={onNewSession}
          onSelectSession={onSelectSession}
        />
      </Drawer>
    );
  },
);
